var React = require('react');

function BowlingBall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M232,240a32,32,0,1,1,32-32A32,32,0,0,1,232,240ZM216,64a32,32,0,1,0,32,32A32,32,0,0,0,216,64ZM120,192a32,32,0,1,0-32-32A32,32,0,0,0,120,192Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM120,192a32,32,0,1,1,32-32A32,32,0,0,1,120,192Zm64-96a32,32,0,1,1,32,32A32,32,0,0,1,184,96Zm48,144a32,32,0,1,1,32-32A32,32,0,0,1,232,240Z","className":"fa-primary","key":2})]);
}

BowlingBall.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = BowlingBall;

BowlingBall.default = BowlingBall;
